import "core-js/modules/es6.regexp.search";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.date.to-iso-string";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import parse from 'html-react-parser';
import { camelCase, upperFirst, isArray, isPlainObject, get } from 'lodash';
import { api, getApi } from 'prismic-javascript';

var bracked = function bracked(str, vars) {
  if (!vars || !str) {
    return str;
  }

  return Object.keys(vars).reduce(function (result, key) {
    if (!vars[key]) {
      return result;
    }

    var replacePattern = new RegExp("{({|%)( |)" + key + "( |)(%|})}");
    return result.replace(replacePattern, vars[key]);
  }, str);
};

var PlainText = function PlainText(_ref) {
  var content = _ref.content,
      variables = _ref.variables;
  return typeof content === 'string' ? React.createElement(React.Fragment, null, parse(bracked(content, variables))) : React.createElement(React.Fragment, null, parse(bracked(RichText.asText(content), variables)));
};

PlainText.propTypes = {
  content: PropTypes.any.isRequired,
  variables: PropTypes.object
};
PlainText.defaultProps = {
  variables: {}
};
/* eslint-disable-next-line max-params */

var serializer = function serializer(variables, type, element, children, content, key) {
  var data = element.data,
      text = element.text;

  if (type !== 'span' && type !== 'hyperlink') {
    return null;
  }

  if (type === 'span') {
    return parse(bracked(text, variables));
  }

  var url = data.url;
  return React.createElement('a', {
    className: 'text-link',
    href: url,
    key: key,
    rel: 'noopener noreferrer',
    target: '_blank'
  }, children);
};

var PrismicReactToolsContext = React.createContext({});

var PrismicReactToolsProvider = function PrismicReactToolsProvider(_ref) {
  var children = _ref.children,
      components = _ref.components,
      serializer$$1 = _ref.serializer;
  return React.createElement(PrismicReactToolsContext.Provider, {
    value: {
      components: components,
      serializer: serializer$$1 ? serializer$$1 : serializer
    }
  }, children);
};

PrismicReactToolsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  components: PropTypes.object,
  serializer: PropTypes.func
};
PrismicReactToolsProvider.defaultProps = {
  components: [],
  serializer: null
};
var PrismicReactToolsConsumer = PrismicReactToolsContext.Consumer;

var renderRichText = function renderRichText(_ref) {
  var content = _ref.content,
      serializer$$1 = _ref.serializer,
      variables = _ref.variables;
  var richTextSerializer = serializer$$1.bind(null, variables);
  return RichText.render(content, null, richTextSerializer);
};

var RichText$1 = function RichText$$1(_ref2) {
  var content = _ref2.content,
      variables = _ref2.variables;
  return React.createElement(PrismicReactToolsConsumer, null, function (_ref3) {
    var serializerFromContext = _ref3.serializerFromContext;
    var serializer$$1 = serializerFromContext || serializer;
    return React.createElement(React.Fragment, null, renderRichText({
      content: content,
      serializer: serializer$$1,
      variables: variables
    }));
  });
};

RichText$1.propTypes = {
  content: PropTypes.any.isRequired,
  variables: PropTypes.object
};
RichText$1.defaultProps = {
  variables: {}
};

var snakeCaseToComponentCase = function snakeCaseToComponentCase(snakeCase) {
  return upperFirst(camelCase(snakeCase));
};

var asyncToGenerator = function asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Slice = function Slice(_ref) {
  var items = _ref.items,
      primary = _ref.primary,
      sliceType = _ref.sliceType;
  return React.createElement(PrismicReactToolsConsumer, null, function (_ref2) {
    var components = _ref2.components;
    var Component$$1 = components[snakeCaseToComponentCase(sliceType)];

    if (!Component$$1) {
      return null;
    }

    return React.createElement(Component$$1, _extends({}, primary, {
      items: items
    }));
  });
};

Slice.propTypes = {
  items: PropTypes.array,
  primary: PropTypes.object,
  sliceType: PropTypes.string.isRequired
};
Slice.defaultProps = {
  items: null,
  primary: null
};

var Slices = function Slices(_ref) {
  var slices = _ref.slices;
  return slices.length ? slices.map(function (slice, index) {
    return React.createElement(Slice, _extends({
      key: index
    }, slice));
  }) : null;
};

Slices.propTypes = {
  slices: PropTypes.array.isRequired
};

var camelcaseToDashcase = function camelcaseToDashcase(camelCaseString, exceptions) {
  var parsedString = camelCaseString;

  if (exceptions) {
    Object.keys(exceptions).forEach(function (key) {
      parsedString = parsedString.replace(key, exceptions[key]);
    });
  }

  parsedString = parsedString.replace(/([A-Z])/g, function (firstWord) {
    return '-' + firstWord[0].toLowerCase();
  });

  if (parsedString[0] === '-') {
    parsedString = parsedString.substr(1);
  }

  return parsedString;
};

var componentCaseToPrismicCase = function componentCaseToPrismicCase(componentCase, _ref) {
  var exceptions = _ref.exceptions;
  var parsedString = componentCase;

  if (exceptions) {
    Object.keys(exceptions).forEach(function (key) {
      parsedString = parsedString.replace(key, exceptions[key]);
    });
  }

  parsedString = parsedString.replace(/([A-Z])/g, function (firstWord) {
    return '-' + firstWord[0].toLowerCase();
  });

  if (parsedString[0] === '-') {
    parsedString = parsedString.substr(1);
  }

  return parsedString;
};

var extractFromCamelCase = function extractFromCamelCase(data, partial, defaultObject) {
  var object = {};
  Object.keys(data).map(function (key) {
    var _key$split = key.split(partial),
        _key$split2 = slicedToArray(_key$split, 2),
        splitKey = _key$split2[1];

    if (splitKey) {
      var newKey = "" + splitKey.charAt(0).toLowerCase() + splitKey.slice(1);
      object[newKey] = data[key];
    }
  });
  return object || defaultObject || {};
};

var keysToCamel = function keysToCamel(object) {
  if (!isPlainObject(object) && !isArray(object)) {
    return object;
  }

  if (isPlainObject(object)) {
    var newObject = {};
    Object.keys(object).forEach(function (key) {
      newObject[camelCase(key)] = keysToCamel(object[key]);
    });
    return newObject;
  }

  return object.map(function (index) {
    return keysToCamel(index);
  });
};

var has = Object.prototype.hasOwnProperty;

var hexTable = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var compactQueue = function compactQueue(queue) {
  var obj;

  while (queue.length) {
    var item = queue.pop();
    obj = item.obj[item.prop];

    if (Array.isArray(obj)) {
      var compacted = [];

      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }

      item.obj[item.prop] = compacted;
    }
  }

  return obj;
};

var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};

  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }

  return obj;
};

var merge = function merge(target, source, options) {
  if (!source) {
    return target;
  }

  if (typeof source !== 'object') {
    if (Array.isArray(target)) {
      target.push(source);
    } else if (typeof target === 'object') {
      if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }

    return target;
  }

  if (typeof target !== 'object') {
    return [target].concat(source);
  }

  var mergeTarget = target;

  if (Array.isArray(target) && !Array.isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }

  if (Array.isArray(target) && Array.isArray(source)) {
    source.forEach(function (item, i) {
      if (has.call(target, i)) {
        if (target[i] && typeof target[i] === 'object') {
          target[i] = merge(target[i], item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }

  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];

    if (has.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }

    return acc;
  }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};

var decode = function decode(str) {
  try {
    return decodeURIComponent(str.replace(/\+/g, ' '));
  } catch (e) {
    return str;
  }
};

var encode = function encode(str) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }

  var string = typeof str === 'string' ? str : String(str);
  var out = '';

  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);

    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    ) {
        out += string.charAt(i);
        continue;
      }

    if (c < 0x80) {
      out = out + hexTable[c];
      continue;
    }

    if (c < 0x800) {
      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
  }

  return out;
};

var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];

  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);

    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];

      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }

  return compactQueue(queue);
};

var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
  if (obj === null || typeof obj === 'undefined') {
    return false;
  }

  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var utils = {
  arrayToObject: arrayToObject,
  assign: assign,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  merge: merge
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var formats = {
  'default': 'RFC3986',
  formatters: {
    RFC1738: function RFC1738(value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function RFC3986(value) {
      return value;
    }
  },
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    // eslint-disable-line func-name-matching
    return prefix + '[]';
  },
  indices: function indices(prefix, key) {
    // eslint-disable-line func-name-matching
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    // eslint-disable-line func-name-matching
    return prefix;
  }
};
var toISO = Date.prototype.toISOString;
var defaults$1 = {
  delimiter: '&',
  encode: true,
  encoder: utils.encode,
  encodeValuesOnly: false,
  serializeDate: function serializeDate(date) {
    // eslint-disable-line func-name-matching
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly) {
  var obj = object;

  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  } else if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder) : prefix;
    }

    obj = '';
  }

  if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder);
      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder))];
    }

    return [formatter(prefix) + '=' + formatter(String(obj))];
  }

  var values = [];

  if (typeof obj === 'undefined') {
    return values;
  }

  var objKeys;

  if (Array.isArray(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (skipNulls && obj[key] === null) {
      continue;
    }

    if (Array.isArray(obj)) {
      values = values.concat(stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
    } else {
      values = values.concat(stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
    }
  }

  return values;
};

var stringify_1 = function stringify_1(object, opts) {
  var obj = object;
  var options = opts ? utils.assign({}, opts) : {};

  if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }

  var delimiter = typeof options.delimiter === 'undefined' ? defaults$1.delimiter : options.delimiter;
  var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults$1.strictNullHandling;
  var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults$1.skipNulls;
  var encode = typeof options.encode === 'boolean' ? options.encode : defaults$1.encode;
  var encoder = typeof options.encoder === 'function' ? options.encoder : defaults$1.encoder;
  var sort = typeof options.sort === 'function' ? options.sort : null;
  var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
  var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults$1.serializeDate;
  var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults$1.encodeValuesOnly;

  if (typeof options.format === 'undefined') {
    options.format = formats['default'];
  } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
    throw new TypeError('Unknown format option provided.');
  }

  var formatter = formats.formatters[options.format];
  var objKeys;
  var filter;

  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (Array.isArray(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }

  var keys = [];

  if (typeof obj !== 'object' || obj === null) {
    return '';
  }

  var arrayFormat;

  if (options.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = options.arrayFormat;
  } else if ('indices' in options) {
    arrayFormat = options.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = 'indices';
  }

  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

  if (!objKeys) {
    objKeys = Object.keys(obj);
  }

  if (sort) {
    objKeys.sort(sort);
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (skipNulls && obj[key] === null) {
      continue;
    }

    keys = keys.concat(stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode ? encoder : null, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
  }

  var joined = keys.join(delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';
  return joined.length > 0 ? prefix + joined : '';
};

var has$1 = Object.prototype.hasOwnProperty;
var defaults$2 = {
  allowDots: false,
  allowPrototypes: false,
  arrayLimit: 20,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  parameterLimit: 1000,
  plainObjects: false,
  strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);

  for (var i = 0; i < parts.length; ++i) {
    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;

    if (pos === -1) {
      key = options.decoder(part, defaults$2.decoder);
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults$2.decoder);
      val = options.decoder(part.slice(pos + 1), defaults$2.decoder);
    }

    if (has$1.call(obj, key)) {
      obj[key] = [].concat(obj[key]).concat(val);
    } else {
      obj[key] = val;
    }
  }

  return obj;
};

var parseObject = function parseObject(chain, val, options) {
  var leaf = val;

  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];

    if (root === '[]') {
      obj = [];
      obj = obj.concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);

      if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }

    leaf = obj;
  }

  return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
  if (!givenKey) {
    return;
  } // Transform dot notation to bracket notation


  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g; // Get the parent

  var segment = brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

  var keys = [];

  if (parent) {
    // If we aren't using plain objects, optionally prefix keys
    // that would overwrite object prototype properties
    if (!options.plainObjects && has$1.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(parent);
  } // Loop through children appending to the array until we hit depth


  var i = 0;

  while ((segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;

    if (!options.plainObjects && has$1.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(segment[1]);
  } // If there's a remainder, just add whatever is left


  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }

  return parseObject(keys, val, options);
};

var parse$1 = function parse$1(str, opts) {
  var options = opts ? utils.assign({}, opts) : {};

  if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }

  options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
  options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults$2.delimiter;
  options.depth = typeof options.depth === 'number' ? options.depth : defaults$2.depth;
  options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults$2.arrayLimit;
  options.parseArrays = options.parseArrays !== false;
  options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults$2.decoder;
  options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults$2.allowDots;
  options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults$2.plainObjects;
  options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults$2.allowPrototypes;
  options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults$2.parameterLimit;
  options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults$2.strictNullHandling;

  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }

  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options);
    obj = utils.merge(obj, newObj, options);
  }

  return utils.compact(obj);
};

var lib = {
  formats: formats,
  parse: parse$1,
  stringify: stringify_1
};

var Prismic = function Prismic(_ref) {
  var accessToken = _ref.accessToken,
      repositoryName = _ref.repositoryName;
  classCallCheck(this, Prismic);

  _initialiseProps.call(this);

  this.accessToken = accessToken;
  this.repositoryName = repositoryName;
  this.apiEndpoint = 'https://' + repositoryName + '.prismic.io/api/v2';
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.getAllDocuments = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var accessToken, apiEndpoint, client, documents;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = _this.accessToken, apiEndpoint = _this.apiEndpoint;
            _context.next = 3;
            return api(apiEndpoint, {
              accessToken: accessToken
            });

          case 3:
            client = _context.sent;
            _context.next = 6;
            return _this.getDocuments({
              client: client,
              lang: '*'
            });

          case 6:
            documents = _context.sent;
            return _context.abrupt('return', {
              documents: documents
            });

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  this.getDocuments = function () {
    var _ref3 = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
      var client = _ref4.client,
          lang = _ref4.lang,
          _ref4$mergedResponse = _ref4.mergedResponse,
          mergedResponse = _ref4$mergedResponse === undefined ? [] : _ref4$mergedResponse,
          _ref4$page = _ref4.page,
          page = _ref4$page === undefined ? 1 : _ref4$page,
          _ref4$pageSize = _ref4.pageSize,
          pageSize = _ref4$pageSize === undefined ? 100 : _ref4$pageSize;

      var _ref5, results, totalResults;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return client.query([], {
                lang: lang,
                page: page,
                pageSize: pageSize
              });

            case 2:
              _ref5 = _context2.sent;
              results = _ref5.results;
              totalResults = _ref5.total_results_size;
              mergedResponse = [].concat(toConsumableArray(mergedResponse), toConsumableArray(results));

              if (!(page * pageSize < totalResults)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt('return', _this.getDocuments({
                client: client,
                lang: lang,
                mergedResponse: mergedResponse,
                page: page + 1,
                pageSize: pageSize
              }));

            case 8:
              return _context2.abrupt('return', keysToCamel(mergedResponse));

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.getPreview = function () {
    var _ref6 = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7) {
      var location = _ref7.location,
          options = _ref7.options;
      var accessToken, apiEndpoint, query, token, now, client, fetchedDocument, prismicDocument, documents, pageContext;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              accessToken = _this.accessToken, apiEndpoint = _this.apiEndpoint;
              query = lib.parse(location.search.slice(1));
              token = query.token;
              now = new Date();
              now.setHours(now.getHours() + 1);
              _context3.next = 8;
              return getApi(apiEndpoint, {
                accessToken: accessToken
              });

            case 8:
              client = _context3.sent;
              _context3.next = 11;
              return client.previewSession(token, function (document) {
                return document;
              });

            case 11:
              fetchedDocument = _context3.sent;
              prismicDocument = keysToCamel(fetchedDocument);
              _context3.next = 15;
              return _this.getDocuments({
                client: client,
                lang: '*'
              });

            case 15:
              documents = _context3.sent; // eslint-disable-next-line no-undef

              if (token && document) {
                // eslint-disable-next-line no-undef
                document.cookie = Prismic.previewCookie + '=' + token + '; expires=' + now.toUTCString() + '; path=/';
              }

              pageContext = typeof options.onCreatePages === 'function' ? options.onCreatePages({
                documents: documents
              }) || {} : {};
              pageContext = _extends({
                document: prismicDocument
              }, pageContext);

              if (typeof options.onCreatePage === 'function') {
                pageContext = _extends({}, pageContext, options.onCreatePage(_extends({
                  document: prismicDocument,
                  documents: documents
                }, pageContext)));
              }

              return _context3.abrupt('return', pageContext);

            case 23:
              _context3.prev = 23;
              _context3.t0 = _context3['catch'](0); // eslint-disable-next-line no-console

              console.log(_context3.t0);
              return _context3.abrupt('return', null);

            case 27:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 23]]);
    }));

    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var getPageComponents = function getPageComponents(pageComponents, exceptions) {
  return Object.keys(pageComponents).reduce(function (result, key) {
    return _extends({}, result, defineProperty({}, camelcaseToDashcase(key, exceptions), pageComponents[key]));
  }, {});
};

var withPrismicPreview = function withPrismicPreview(_ref) {
  var _class, _temp2;

  var pageComponents = _ref.pageComponents,
      options = objectWithoutProperties(_ref, ['pageComponents']);
  var pages = getPageComponents(pageComponents, options.layoutNameExceptions);
  return _temp2 = _class = function (_Component) {
    inherits(WithPrismicPreview, _Component);

    function WithPrismicPreview() {
      var _ref2,
          _this2 = this;

      var _temp, _this, _ret;

      classCallCheck(this, WithPrismicPreview);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = WithPrismicPreview.__proto__ || Object.getPrototypeOf(WithPrismicPreview)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
        isLoading: true
      }, _this.getPreviewPage = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var location, api$$1, pageContext;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                location = _this.props.location;
                api$$1 = new Prismic(options);
                _context.next = 4;
                return api$$1.getPreview({
                  location: location,
                  options: options
                });

              case 4:
                pageContext = _context.sent;
                return _context.abrupt('return', _this.setState({
                  isLoading: false,
                  pageContext: pageContext
                }));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      })), _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(WithPrismicPreview, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.getPreviewPage();
      }
    }, {
      key: 'render',
      value: function render() {
        var isLoading = this.state.isLoading;
        var document = get(this.state, 'pageContext.document');

        if (isLoading) {
          return React.createElement('div', null, 'Loading...');
        }

        if (!document || !document.type) {
          return React.createElement('div', null, React.createElement('h1', null, 'No data or your token has expired'), React.createElement('p', null, 'Click on prismic preview icon to refresh...'));
        }

        var Page = pages[document.type.replace(options.layoutsKey, '')];

        if (!Page) {
          return React.createElement('div', null, 'No preview for "', document.type, '"');
        }

        return React.createElement(Page, _extends({}, this.props, this.state));
      }
    }]);
    return WithPrismicPreview;
  }(Component), _class.defaultProps = {
    location: {}
  }, _class.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string
    })
  }, _temp2;
};

export { PlainText, PrismicReactToolsProvider, PrismicReactToolsConsumer, RichText$1 as RichText, Slice, Slices, bracked, camelcaseToDashcase, componentCaseToPrismicCase, extractFromCamelCase, keysToCamel, snakeCaseToComponentCase, withPrismicPreview };